import { PrimaryPaper } from "Components/Shared/PrimaryPaper";
import { HunterTransactionFees } from "Components/Transactions/UserTransactionFees/HunterTransactionFees";
import { MerchantTransactionFees } from "Components/Transactions/UserTransactionFees/MerchantTransactionFees";
import type { SettlementUserRole } from "Types/settlements";
import { AccessRoleCodes } from "Models/AccessRoleCodes";
import type { ReactNode } from "react";

type Props = {
  userID: number;
  partyPublicID: string;
  userRole: SettlementUserRole;
};

export const UserTransactionFees = ({ userID, ...restProps }: Props) => {
  const userRoleToTransactionFees: Record<SettlementUserRole, ReactNode> = {
    [AccessRoleCodes.Merchant]: <MerchantTransactionFees {...restProps} />,
    [AccessRoleCodes.Hunter]: (
      <HunterTransactionFees userID={userID} {...restProps} />
    ),
    [AccessRoleCodes.HunterPlus]: (
      <HunterTransactionFees userID={userID} {...restProps} />
    ),
  };

  return (
    <PrimaryPaper sx={{ py: 4 }}>
      {userRoleToTransactionFees[restProps.userRole]}
    </PrimaryPaper>
  );
};
